<template>
  <div>
    <!-- 搜索 -->
    <search ref="search" @productList="productList" @isAllShow="isAllShow" @batchAudit="batchAudit"
      :tableData="tableData" :audit-mode="auditMode" />
    <!-- 列表 -->
    <div class="table">
      <ol>
        <li class="flex03">NO</li>
        <!-- 客户信息 -->
        <li>{{ $t('message.userInfo') }}</li>
        <!-- 管理番号 -->
        <li class="flex15">{{ $t('message.managementDesignation') }}</li>
        <!-- 主图 -->
        <li class="flex05">{{ $t('message.mainImage') }}</li>
        <!-- SKU -->
        <li>SKU</li>
        <!-- 附加服务 -->
        <li>{{ $t('message.additionalServices') }}</li>
        <!-- 标签信息 -->
        <li class="flex15">{{ $t('message.tagInformation') }}</li>
        <!-- 绑定辅料 -->
        <li>{{ $t('message.bindingAuxiliaryMaterials') }}</li>
        <!-- 商品管理备注 -->
        <li class="flex15">{{ $t('message.productManagementRemarks') }}</li>
        <!-- 通关信息 -->
        <li>{{ $t('message.customsClearanceInformation') }}</li>
        <!-- 产品类型 -->
        <li>{{ $t('message.productType') }}</li>
        <!-- 最新更新时间 -->
        <li>{{ $t('message.lastUpdateTime') }}</li>
        <!-- 操作 -->
        <li class="flex05">{{ $t('message.operation') }}</li>
      </ol>
      <div class="detail" v-for="(item, index) in tableData" :key="index">
        <!-- 列表 -->
        <ul>
          <li class="flex03">
            <div>{{ item.rowNumber }}
              <p style="margin-top: 8px;">
                <el-checkbox v-model="item.checked" :disabled="auditMode && item.audit_status == 3"></el-checkbox>
              </p>
            </div>
            <!-- 标识 -->
            <div class="label">
              <el-button v-if="item.edit_status == 1" size="mini" type="primary"> 待维护</el-button>
              <el-button v-if="item.edit_status == 2" size="mini" type="success"> 维护完成</el-button>
              <el-button v-if="item.edit_status == 3" size="mini" type="info"> 无需维护</el-button>
            </div>
          </li>
          <!-- 客户信息 -->
          <li>
            <div>
              <p>{{ item.user.realname }}</p>
              <p>{{ item.user.id }}</p>
            </div>
          </li>
          <!-- 管理番号 -->
          <li class="flex15">
            <div class="template">
              <p class="audit-status"
                v-if="auditMode && (item.audit_status == 2 || item.audit_status == 3 || item.audit_status == 4)">
                <el-tag v-if="item.audit_status == 2" type="danger" size="mini">待审核</el-tag>
                <el-tag v-else-if="item.audit_status == 3" type="success" size="mini">已审核</el-tag>
                <el-tag v-else-if="item.audit_status == 4" type="warning" size="mini">已驳回</el-tag>
              </p>
              <p class="code">
                <!-- <el-input v-model="item.client_sku_code" placeholder="客户商品管理番号"></el-input> -->
                {{ item.client_sku_code }}
                <i class="el-icon-edit-outline" @click="modifyProductNumber(item, index)"></i>
              </p>

              <p>
                <i class="el-icon-link" @click="itemLink(item)"></i>
              </p>
              <div class="tags">
                <div class="item" v-for="(flag, flagIndex) in item.client_product_flag" :key="flagIndex"
                  :style="{ background: flag.color }">
                  {{ flag.name }}
                </div>
              </div>
            </div>
          </li>
          <!-- 主图 -->
          <li class="flex05">
            <el-image style="width: 70px;height: 70px;border-radius: 6px;" :src="item.pic"
              :preview-src-list="[item.pic]">
            </el-image>
          </li>
          <!-- SKU -->
          <li>
            <div>
              <p v-for="(detail, detailIndex) in getSkuDetail(item)" :key="detailIndex">
                {{ detail.key }} :{{ detail.value }}
              </p>
            </div>
          </li>
          <!-- 附加服务 -->
          <li>
            <div class="template">
              <el-tooltip placement="bottom">
                <div slot="content">
                  <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex" style="margin-bottom: 3px">
                    <p>
                      {{ optiIndex + 1 }}){{ opti.name }}
                    </p>
                  </div>
                </div>
                <div style="height: 100px">
                  <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex">
                    <p>
                      {{ optiIndex + 1 }}).{{ opti.name }}
                    </p>
                  </div>
                </div>
              </el-tooltip>
            </div>
          </li>
          <!-- 标签信息 -->
          <li class="flex15">
            <div class="template">
              <el-tooltip placement="bottom">
                <div slot="content">
                  <div class="row" v-for="(tag, tagIndex) in item.client_product_tag" :key="tagIndex"
                    style="border-radius: 4px;padding: 5px; height: 80px;">
                    <p>
                      标签类别：{{ tag.type }}
                    </p>
                    <p>标签条码：{{ tag.no }}</p>
                    <p>商品编码：{{ tag.goods_no }}</p>
                  </div>
                </div>

                <div class="row" v-for="(tag, tagIndex) in item.client_product_tag" :key="tagIndex"
                  style="background: #F6F6F6;border-radius: 4px;padding: 5px; height: 100px;">
                  <p>
                    标签类别：{{ tag.type }}
                  </p>
                  <p>标签条码：{{ tag.no }}</p>
                  <p>商品编码：{{ tag.goods_no }}</p>
                </div>
              </el-tooltip>
            </div>
          </li>
          <!-- 绑定辅料 -->
          <li>
            <div class="template material-template" v-if="item.client_product_material_list.length">
              <el-tooltip placement="bottom">
                <div slot="content">
                  <div class="material-row" v-for="material in item.client_product_material_list"
                    :key="material.material_id">
                    <p>{{ material.name_trans }}</p>

                    <p>消耗：{{ material.consume }} 点/套</p>
                  </div>
                </div>
                <div>
                  <div class="material-row" v-for="material in item.client_product_material_list"
                    :key="material.material_id">
                    <p class="material-name">{{ material.name_trans }}</p>
                    <p>消耗：{{ material.consume }} 点/套</p>
                  </div>
                </div>
              </el-tooltip>
            </div>
            <span v-else>-</span>
          </li>
          <!-- 商品管理备注 -->
          <li class="flex15">
            <div class="template word-break" :title="item.remark">
              {{ item.remark }}
            </div>
          </li>
          <!-- 通关信息 -->
          <li>
            <div v-if="item.client_product_clearance != null">
              <p>品名:
                <span v-if="item.client_product_clearance.pingming_en"> {{ item.client_product_clearance.pingming_en
                }}</span>
                <span v-else-if="item.client_product_clearance.pingming_ja"> {{
                  item.client_product_clearance.pingming_ja }}</span>
                <span v-else-if="item.client_product_clearance.pingming_zh"> {{
                  item.client_product_clearance.pingming_zh }}</span>
              </p>
              <p>材质:
                <span v-if="item.client_product_clearance.material_en"> {{ item.client_product_clearance.material_en
                }}</span>
                <span v-else-if="item.client_product_clearance.material_ja"> {{
                  item.client_product_clearance.material_ja }}</span>
                <span v-else-if="item.client_product_clearance.material_zh"> {{
                  item.client_product_clearance.material_zh }}</span>
              </p>
              <p>
                HSCODE: {{ item.client_product_clearance.hscode }}
              </p>
              <p>
                税率: {{ item.client_product_clearance.tax_rate }}
              </p>
            </div>
          </li>
          <!-- 产品类型 -->
          <li>
            <div>
              <el-tag :type="client_product_supply_type(item.client_product_supply_type, '现货') ? 'success' : 'primary'"
                size="small">
                现货 {{ client_product_supply_type(item.client_product_supply_type, '现货') ? '支持' : '不支持' }}
              </el-tag>
              <el-tag :type="client_product_supply_type(item.client_product_supply_type, 'OEM') ? 'success' : 'primary'"
                size="small">
                OEM {{ client_product_supply_type(item.client_product_supply_type, 'OEM') ? '支持' : '不支持' }}
              </el-tag>
              <el-tag :type="client_product_supply_type(item.client_product_supply_type, 'ODM') ? 'success' : 'primary'"
                size="small">
                ODM {{ client_product_supply_type(item.client_product_supply_type, 'ODM') ? '支持' : '不支持' }}
              </el-tag>
            </div>
          </li>
          <!-- 最新更新时间 -->
          <li>
            {{ item.updated_at }}
          </li>
          <!-- 操作 -->
          <li class="flex05">
            <template v-if="auditMode">
              <div class="audit-actions" v-if="item.audit_status == 2">
                <el-button type="success" size="mini" @click="auditItem(item, 'approve')">审核</el-button>
                <el-button type="warning" size="mini" @click="auditItem(item, 'reject')">打回</el-button>
              </div>
            </template>
            <template v-else>
              <!--  管理番号停用 管理番号启用-->
              <el-button type="text" class="is_hide" @click="switchHide(item, index)"
                :style="{ color: item.is_hide != 1 ? '#B4272D' : '#67C23A' }">{{
                  item.is_hide ==
                    1 ? $t('message.activateManagementNumber') : $t('message.deactivateManagementNumber') }}</el-button>
              <!-- 信息维护 -->
              <router-link :to="'/informationMaintenanceDetail?sys_code=' + item.sys_code" target="_blank"
                class="informationMaintenance">
                <el-button type="primary">{{ $t('message.informationMaintenance') }}</el-button>
              </router-link>
            </template>
          </li>
        </ul>
        <!-- 是否展开 -->
        <div class="isShow" @click="item.show = !item.show">
          <span v-if="item.show">
            收起 <i class="el-icon-arrow-right"></i>
          </span>
          <span v-else>
            展开 <i class="el-icon-arrow-down"></i>
          </span>
        </div>
        <div class="content" v-show="item.show">
          <!-- 商品名称 -->
          <div class="goods-title goods-item">
            <div class="item" style="margin-bottom: 10px;">
              <!-- 商品名称（中文）商品名称（日文）', -->
              <div class="name">
                {{ $t('message.productNameChinese') }}
              </div>
              <p>{{ item.goods_title_cn }}</p>
            </div>
            <div class="item">
              <div class="name">
                {{ $t('message.productNameJapanese') }}
              </div>
              <p>{{ item.goods_title }}</p>
            </div>
          </div>
          <!--  实物图-->
          <div class="physicalImage  goods-item">
            <div class="name">{{ $t('message.physicalImage') }}</div>
            <div class="picList">
              <el-image style="width: 102px;height: 102px;;border-radius: 5px; " :src="pic.url"
                :preview-src-list="[pic.url]" v-for="(pic, picIndex) in item.client_product_image" :key="picIndex"
                :style="{ marginRight: picIndex == 0 ? '12px' : 0 }">
              </el-image>
            </div>
          </div>
          <!--  捆包图-->
          <div class="physicalImage  goods-item">
            <div class="name">{{ $t('message.packingDiagram') }}</div>
            <div class="picList">
              <el-image style="width: 102px;height: 102px;;border-radius: 5px; margin-right: 0px;" :src="pic.url"
                :preview-src-list="[pic.url]" v-for="(pic, picIndex) in item.client_product_image_pack" :key="picIndex"
                :style="{ marginRight: picIndex == 0 ? '12px' : 0 }" v-show="picIndex < 2">
              </el-image>
            </div>
          </div>
          <!-- 商品文件 -->
          <div class="productFile goods-item">
            <div class="name">{{ $t('message.productFile') }}</div>
            <div class="file">
              <!--商品定制文件  -->
              <div class="item" v-for="(file, fileIndex) in item.client_product_file_cate" :key="fileIndex">
                <div class="item-name">{{ file.cate_name }}</div>
                <div class="file-item" v-for="(product_file, product_file_index) in file.client_product_file"
                  :key="product_file_index">
                  <a :href="product_file.url" target="_blank" rel="noopener noreferrer" class="a-link">{{
                    product_file.name }}</a>
                </div>
              </div>

            </div>
          </div>
          <!-- 是否违禁 -->
          <div class="prohibitions">
            <div class="illegal">
              <div class="item" v-for="(forbid, forbidIndex) in item.forbid_type" :key="forbidIndex">
                <img src="@/assets/icon/illegal.png" alt="">
                <div>{{ forbid.value }}</div>
              </div>
            </div>
            <p>{{ item.length }}cm*{{ item.width }}cm*{{ item.height }}cm</p>
            <p>{{ item.weight }}g</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[10, 20, 30, 40]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 客户商品管理番号 -->
    <managementNumber ref="managementNumber" />
    <!--  修改 商品管理番号-->
    <updateItemCode ref="updateItemCode" />
  </div>
</template>
<script>
import search from './dataMaintenance/search'
import managementNumber from './dataMaintenance/managementNumber'
import updateItemCode from './dataMaintenance/updateItemCode'
export default {
  props: {
    auditMode: { type: Boolean, default: false }
  },
  components: {
    search,
    managementNumber,
    updateItemCode
  },
  data() {
    return {
      datas: {},
      total: 0,
      tableData: [],
      index: 0
    };
  },
  created() {

  },
  methods: {
    // 数据维护
    productList(data) {
      this.datas = data
      this.$api.productManagementApi.productList(this.datas).then(res => {
        console.log(res);
        res.data.data.forEach(item => {
          item.show = false
          item.checked = false
          item.client_product_image = []
          item.client_product_material_list = this.getProductMaterialList(item.client_product_material)
          const linkList = item.client_product_link || []
          linkList.forEach(items => {
            const imageList = items.client_product_image_real || []
            imageList.forEach(url => {
              item.client_product_image.push(url)
            })

          })
        })
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    // 全部展开或者收起
    isAllShow(show) {
      this.tableData.forEach(item => {
        item.show = show
      })
      this.$forceUpdate()
    },
    //更新页数
    handleCurrentChange(val) {
      this.datas.page = val;
      this.productList(this.datas);
    },
    //更新分页每页数量
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.productList(this.datas);
    },
    //产品类型
    client_product_supply_type(list, name) {
      let index = (list || []).findIndex(item => item.type_name == name)
      return index != -1
    },
    // 获取 SKU 属性，兼容 client_product_link 或 item_sku 缺失的情况
    getSkuDetail(item) {
      const link = item.client_product_link && item.client_product_link[0]
      return link && link.item_sku && link.item_sku.detail ? link.item_sku.detail : []
    },
    // 获取绑定辅料展示列表
    getProductMaterialList(list) {
      return (list || []).map(item => {
        const material = item.material_detail || item.material || {}
        return {
          material_id: item.material_id || material.id || item.id,
          name_trans: this.getFirstValue([material.name_trans, item.name_trans]),
          type_name: this.getFirstValue([material.type && material.type.name, material.type_name, item.type_name]),
          consume: this.getFirstValue([item.consume, material.consume], 1),
        }
      })
    },
    // 获取第一个有效字段值
    getFirstValue(list, defaultValue = '') {
      const value = list.find(item => item !== undefined && item !== null && item !== '')
      return value !== undefined ? value : defaultValue
    },
    //客户商品管理番号
    itemLink(item) {
      this.$refs.managementNumber.list = JSON.parse(JSON.stringify(item.client_product_link))
      console.log(item.client_product_link);
      this.$refs.managementNumber.datas.user_id = item.user_id
      this.$refs.managementNumber.client_sku_code = item.client_sku_code
      this.$refs.managementNumber.dialogVisible = true
    },
    // 番号是否停用
    switchHide(item, index) {
      let datas = {
        sys_code_set: [item.sys_code],
        is_hide: item.is_hide == 1 ? 0 : 1
      }
      this.$api.productManagementApi.switchHide(datas).then(res => {
        this.tableData[index].is_hide = item.is_hide == 1 ? 0 : 1
        this.$forceUpdate()
        this.$message.success(res.msg)
      })
    },
    //修改商品番号
    modifyProductNumber(item, index) {
      this.index = index
      this.$refs.updateItemCode.datas = {
        user_id: item.user_id,
        sys_code: item.sys_code,
        client_sku_code: item.client_sku_code,
      }
      this.$refs.updateItemCode.dialogVisible = true
    },
    // 单条审核/打回
    auditItem(item, action) {
      this.submitAudit(action, [item])
    },
    // 批量审核/打回
    batchAudit(action) {
      const checkedList = this.tableData.filter(item => item.checked && item.audit_status != 3)
      if (!checkedList.length) return this.$message.error('请选择要操作的列表')
      this.submitAudit(action, checkedList)
    },
    // 提交审核操作
    submitAudit(action, list) {
      const sys_code_set = list.map(item => item.sys_code)
      if (action === 'reject') {
        this.$prompt('请输入打回原因', '打回', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputValidator: value => !!(value && value.trim()),
          inputErrorMessage: '请输入打回原因'
        }).then(({ value }) => {
          this.requestAudit('batchAuditReject', sys_code_set, value.trim())
        }).catch(() => { })
        return
      }
      this.$confirm('确认审核所选商品？', '审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.requestAudit('batchAuditApprove', sys_code_set, '')
      }).catch(() => { })
    },
    requestAudit(apiName, sys_code_set, audit_remark) {
      this.$api.productManagementApi[apiName]({
        sys_code_set,
        audit_remark
      }).then(res => {
        this.$message.success(res.msg)
        this.productList(this.datas)
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.table {
  li {
    justify-content: left;
    padding: 0 10px;
    position: relative;

    .redact {
      position: absolute;
      top: 0px;
      right: 3px;
    }

    .label {
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .el-tag {

      margin-bottom: 5px;
    }
  }

  .flex03 {
    flex: 0.3;
    justify-content: center;
    padding: 0;
  }

  .flex15 {
    flex: 1.5;
  }

  .flex05 {
    flex: 0.5;

    .is_hide {
      position: absolute;
      top: 5px;
      right: 0;
      padding: 0;
    }

    .informationMaintenance {
      position: absolute;
      top: 50%;
      right: 0%;
      transform: translate(-00%, -50%);
    }

    .audit-actions {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      .el-button {
        margin: 4px 0;
      }
    }

  }

  ol {
    height: 56px;
  }

  ul {
    background-color: #fff;
    height: 120px;
    padding: 5px 0;
    border: none;

    .tags {
      display: flex;

      .item {
        padding: 5px 7px;
        border-radius: 4px;
        background-color: pink;
        margin-right: 6px;
        color: #fff;
      }
    }

    .el-icon-link {
      margin: 4px 0;
      display: flex;
      width: 36px;
      height: 36px;
      color: #0D4FE6;
      background: #F2F6FF;
      border-radius: 4px;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.template {
  overflow: hidden;
  width: 100%;
  height: 100px;

  .code {
    display: flex;
    justify-content: space-between;

    i {
      cursor: pointer;
      font-size: 18px;

      &:hover {
        color: #B4272D;
      }
    }
  }
}

.material-template {
  .material-row {
    margin-bottom: 6px;
    padding: 5px;
    background: #F6F6F6;
    border-radius: 4px;

    .material-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.detail {
  position: relative;
  border-bottom: 1px solid #ccc;

  .isShow {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 66px;
    height: 30px;
    background: #F6F6F6;
    border-radius: 4px 4px 0px 0px;
    border: 1px solid #DFDFDF;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    border-bottom: 0;
  }
}

.content {
  display: flex;
  padding: 12px 0 21px;

  .goods-item {
    position: relative;

    .name {
      font-weight: bold;
      font-size: 14px;
      color: #333333;
      margin-bottom: 10px;
    }
  }

  .redact {
    position: absolute;
    top: 0;
    right: 0;
  }

  .goods-title {
    width: 218px;
    padding: 17px;
    margin-right: 12px;

  }

  .physicalImage {
    width: 218px;
    padding: 17px;
    margin-right: 12px;
  }

  .productFile {
    width: 720px;
    padding: 17px;

    .file {
      display: flex;

      .item {
        width: 220px;
        padding: 10px;
        margin-right: 12px;
        background-color: #fff;
        border-radius: 4px;
        height: 82px;

        &:nth-last-child(1) {
          margin: 0;
        }

        .item-name {
          margin-bottom: 8px;
        }
      }
    }
  }

  .prohibitions {
    padding: 17px;
    width: 218px;

    .illegal {
      display: flex;
      flex-wrap: wrap;

      .item {
        width: 70px;
        text-align: center;
        margin-right: 28px;
        margin-bottom: 10px;

        img {
          width: 23px;
          margin-bottom: 8px;
        }
      }
    }

    p {
      margin-top: 16px;
    }
  }
}

/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}
</style>
